import { jsx as _jsx } from "react/jsx-runtime";
import { useClassName } from '../../../../hooks';
import './Text.scss';
/**
 * Text component used to display regular text.
 */
export const Text = ({ size = 'md', weight = 'medium', Tag = 'p', children, color = 'black', pointerEvents = 'auto', fullWidth, whiteSpace, ellipsis, }) => {
    const className = useClassName({ name: 'typography', prefixed: true }, { name: 'typography-text', prefixed: true }, size, weight, color, fullWidth && 'w-full', `pointer-events-${pointerEvents}`, whiteSpace && `whitespace-${whiteSpace}`, ellipsis && 'ellipsis');
    return _jsx(Tag, { className: className, children: children });
};
